import Icon from '@mdi/react';
import { Paper, Typography } from '@mui/material';
import styled from 'styled-components';

const MetricPaper = styled(Paper)`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const MetricTitle = styled.div`
    display: flex;
    align-items: center;
    margin: 20px auto 20px auto;
`;

const MetricTitleText = styled(Typography)`
    display: inline;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.15000000596046448px;
    margin-left: 6px;
`;

const MetricTitleIcon = styled(Icon)`
    display: inline;
    width: 20px;
`;

const AmountText = styled(Typography)`
    display: block;
    font-family: Lato;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px;
    letter-spacing: 0.25px;
`;

export { MetricPaper, MetricTitle, MetricTitleText, MetricTitleIcon, AmountText };
